import AWS from 'aws-sdk';
import { Auth } from '@aws-amplify/auth';
import { Amplify } from 'aws-amplify';

import * as GlobalConstants from '../data/GlobalConstants.js';
import * as RedshiftDataApiConstants from '../data/RedshiftDataApiConstants.js';

Amplify.configure({
    Auth: {
        mandatorySignIn: false,
        region: GlobalConstants.AWS_REGION_NAME,
        userPoolId: GlobalConstants.AWS_USER_POOL_ID,
        userPoolWebClientId: GlobalConstants.AWS_USER_POOL_WEB_CLIENT_ID,
        identityPoolId: GlobalConstants.AWS_IDENTITY_POOL_ID
    },
});

AWS.config.region = GlobalConstants.AWS_REGION_NAME;

async function getMemberFromCurrentSeasonLoggedWithPin(userId, userPin, userNif, userBirthDate){
    if(!userNif && !userBirthDate) {
        throw new Error (GlobalConstants.NIF_BIRTHDATE_REDSHIFT_DATA_API_ERROR);
    }

    const sql_params = [
        userId,
        userPin,
    ];

    if(userNif) sql_params.push(userNif);
    else sql_params.push(userBirthDate);

    const sql_query =
        'SELECT\n' +
        'm.pk_id, mm.name, mm.first_name, mm.last_name, mm.email, mm.birthdate, mm.mobile_phone, mm.type, mm.pk_id as id_betis, mm.id_tipo' 
             + '\n' +
        'FROM master_member mm LEFT JOIN member m ON mm.pk_id = m.fk_master_member_id ' +
        'AND m.fk_season_id IN ' +
            '(SELECT pk_id FROM season WHERE start_date < CAST(GETDATE() AS DATE) and end_date > CAST(GETDATE() AS DATE)) \n' +
        'WHERE m.pk_id = $1 ' +
            'AND m.pin = $2 ' +
            'AND ' +
                ((userNif) ? 'm.nif = $3' : '') +
                ((!userNif && userBirthDate) ? 'm.birthDate = $3' : '');

    return await executeQuery(sql_query, sql_params);
}

async function getMemberToVerify(userId, userEmail){
    const lowercasedEmail = userEmail.toLowerCase();
    if(!userId && !lowercasedEmail) {
        throw new Error (GlobalConstants.ID_EMAIL_REDSHIFT_DATA_API_ERROR);
    }

    const sql_params = [
        userId,
        lowercasedEmail,
    ];

    const sql_query =
        'SELECT\n' +
            RedshiftDataApiConstants.REDSHIFT_MEMBER_FIELDS.join(', ')  + '\n' +
        'FROM member\n' +
        'WHERE pk_id = $1 ' +
            'AND email = $2 ' +
            'AND fk_season_id IN ' +
                '(SELECT pk_id FROM season WHERE start_date < CAST(GETDATE() AS DATE) and end_date > CAST(GETDATE() AS DATE))';

    return await executeQuery(sql_query, sql_params);
}

async function getPinFromEmail(email, userId) {
    const lowercasedEmail = email.toLowerCase();
    const sql_params = [lowercasedEmail, userId];
    const sql_query =
        'SELECT\n' +
        RedshiftDataApiConstants.REDSHIFT_MEMBER_PIN_FIELD.join(', ') +
        '\n' +
        'FROM member\n' +
        'WHERE email = $1 ' +
        'AND pk_id = $2 ' +
        'AND fk_season_id IN ' +
                '(SELECT pk_id FROM season WHERE start_date < CAST(GETDATE() AS DATE) and end_date > CAST(GETDATE() AS DATE))';

    return await executeQuery(sql_query, sql_params);
}

async function getMembersFromEmail(email) {
    const lowercasedEmail = email.toLowerCase();
    const sql_params = [lowercasedEmail];
    const sql_query =
        'SELECT\n' +
        'm.pk_id, mm.name, mm.first_name, mm.last_name, mm.email, mm.birthdate, mm.mobile_phone, mm.type, mm.pk_id as id_betis, mm.id_tipo' +
        '\n' +
        'FROM master_member mm LEFT JOIN member m ON mm.pk_id = m.fk_master_member_id\n' +
        'AND m.fk_season_id IN ' +
                '(SELECT pk_id FROM season WHERE start_date < CAST(GETDATE() AS DATE) and end_date > CAST(GETDATE() AS DATE)) \n' +
        'WHERE mm.email = $1' ; 

    return await executeQuery(sql_query, sql_params);
}

async function executeQuery(sql_query, sql_params){

    const lambda = await Auth.currentCredentials().then((credentials) => {
        return new AWS.Lambda({
            credentials: Auth.essentialCredentials(credentials),
        });
    });

    const params = {
        FunctionName: GlobalConstants.LAMBDA_REDSHIFT_API_NAME,
        InvocationType: GlobalConstants.LAMBDA_INVOCATION_TYPE,
        Payload: JSON.stringify({
            'Details': {
                'Parameters': {
                    'sql_query': sql_query,
                    'sql_params': sql_params
                }
            }
        })
    };

    const lambdaInvokeResp = await lambda.invoke(params).promise();
    const response = JSON.parse(lambdaInvokeResp.Payload);
    return response;
}

async function getAccionistaFromPinNif(userId, userPin, userNif){
    if(!userNif) {
        throw new Error (GlobalConstants.NIF_BIRTHDATE_REDSHIFT_DATA_API_ERROR);
    }

    const sql_params = [
        userId,
        userPin,
        userNif,
    ];

    const sql_query =
        'SELECT' +
        'ma.pk_id, ma.nombre as name, ma.apellido1 as first_name, ma.apellido2 as last_name, ma.pk_id as id_betis, mm.email, mm.type, mm.id_tipo' +
        'FROM member_accionista ma' +
        'LEFT JOIN master_member mm ON ma.fk_master_member_id = mm.pk_id' +
        'WHERE ma.acreditacion = $1 ' +
            'AND ma.pin = $2 ' +
            'AND ma.nif = $3';

    return await executeQuery(sql_query, sql_params);
}
export { getMemberFromCurrentSeasonLoggedWithPin, getMemberToVerify, getPinFromEmail, getMembersFromEmail, getAccionistaFromPinNif  }
